<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <BoxIcon />
      <h2 class="text-lg font-medium mr-auto">{{ $t('posDevices.list') }}</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
      </div>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <ListTable />
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ListTable from '@/components/pos-devices/ListTable'

export default defineComponent({
  components: {
    ListTable
  },
  setup() {
    return {}
  }
})
</script>
